module.exports = function() {
  return new Worker(__webpack_public_path__ + "f363a800a8cc297d8125.worker.js");
};